import type { MouseEvent } from 'react'

import { Icon } from '../core/Icon'
import { Tooltip } from '../core/Tooltip'
import { styled } from '../styles'

export type ResetToDefaultButtonProps = {
  onReset: () => void
  tooltip?: string
  ariaLabel: string
}

const ResetIconButton = styled('button')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  border: 'none',
  background: 'none',
  padding: 0,
  margin: 0,
}))

export const ResetToDefaultButton = ({ onReset, tooltip, ariaLabel }: ResetToDefaultButtonProps) => {
  const handleReset = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onReset()
  }

  const button = (
    <ResetIconButton type="button" aria-label={ariaLabel} onMouseDown={handleReset} onClick={handleReset}>
      <Icon icon="refresh" size="small" />
    </ResetIconButton>
  )

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button
}
